import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield } = FiIcons;

export default function BaziExplanation() {
  return (
    <section id="bazi-info" className="section-padding bg-zinc-50 border-t border-zinc-200 overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 relative">
        <div className="absolute top-0 right-0 opacity-[0.03] scale-150 rotate-12 pointer-events-none text-zinc-900">
           {/* Abstract Decoration */}
           <SafeIcon icon={FiShield} className="w-96 h-96" />
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white border-[6px] border-zinc-900 p-8 md:p-20 shadow-[30px_30px_0px_0px_rgba(0,0,0,0.05)] relative z-10"
        >
          <div className="flex flex-col items-center">
            <div className="inline-flex items-center gap-4 bg-brand-red text-white px-8 py-3 mb-12 font-black uppercase tracking-[0.2em] text-xs">
              <SafeIcon icon={FiShield} className="w-4 h-4" /> Why BAZI Matters
            </div>
            
            <h2 className="text-4xl md:text-6xl font-black text-zinc-900 mb-12 text-center leading-tight tracking-tighter">
              ปาจื้อ (BAZI) <br className="hidden md:block" />
              <span className="text-zinc-400">คือรหัสผ่านความมั่งคั่ง</span>
            </h2>
            
            <div className="space-y-8 text-zinc-700 text-xl leading-relaxed text-left md:text-center max-w-3xl">
              <p className="font-semibold text-zinc-900">
                BAZI หรือ ปาจื่อ (สี่เสาหลักแห่งชะตา) เป็นวิชาโหราศาสตร์จีนโบราณที่มีประวัติยาวนานกว่าพันปี อาศัยการคำนวณ วัน เดือน ปี และเวลาเกิด เพื่อหา <span className="text-brand-red font-black underline decoration-zinc-200 underline-offset-8">"รหัสธาตุ"</span> ประจำตัว
              </p>
              
              <div className="py-12 my-12 border-y-2 border-zinc-100 relative">
                <p className="text-2xl md:text-3xl font-black text-zinc-900 leading-tight italic">
                  BAZI ไม่ได้แค่มีไว้ทำนายอนาคต (แม้ว่าจะทำนายได้อย่างแม่นยำก็ตาม) แต่มีไว้เพื่อทำความเข้าใจบุคลิก ลักษณะนิสัย และการตัดสินใจของคุณเอง
                </p>
              </div>

              <div className="bg-zinc-900 text-white p-10 md:p-16 my-16 relative overflow-hidden group">
                <p className="text-2xl md:text-3xl font-black text-brand-red mb-6 uppercase tracking-widest">
                  ขอย้ำอีกครั้งว่า...
                </p>
                <p className="text-2xl md:text-4xl font-black italic text-white tracking-tight leading-tight">
                  "ชะตากรรมของคุณไม่ได้ถูกกำหนดไว้ล่วงหน้า <br /> โดยแก้ไขอะไรไม่ได้เลย"
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}